export default __webpack_public_path__ + "static/media/cityviewer.3109277e.png";